<script setup>
import {onMounted, reactive, ref, watch} from "vue";
import dashboardService from "@/services/ecosystem/dashboard.service";
import {getLogo} from "@/helpers/logo";
import VClamp from "vue-clamp";

const statusLabels = {
    unreviewed: 'Unreviewed',
    liked: 'Accepted',
    disliked: 'Rejected',
    escalated: 'Escalated',
};

const statusClasses = {
    unreviewed: 'status-plate--unreviewed',
    liked: '',
    disliked: 'status-plate--rejected',
    escalated: 'status-plate--evaluate',
};

const startups = ref([]);

const filters = reactive({
    search: '',
});

watch(filters, () => {
    getList();
});

onMounted(() => {
    getList();
});

function applySearch(search) {
    filters.search = search;
}

async function getList() {
    const {data} = await dashboardService.getSubmittedStartupsList(filters);
    startups.value = data;
}
</script>

<template>
    <div id="submitted-startups" class="dashboard-page__card dashboard-page__card--round">
        <div class="dashboard-page__card__inner">
            <header class="dashboard-page__card__header">
                <h3 class="dashboard-page__title dashboard-page__title--submitted">Submitted</h3>

                <div class="ml-auto">
                    <input v-debounce:500ms="applySearch" type="text" placeholder="Search for a startup" class="dashboard-page__search">
                </div>
            </header>
        </div>

        <div class="dashboard-page__table dashboard-page__table-flexible">
            <table>
                <thead>
                <tr>
                    <th>Submitted Startup</th>
                    <th class="dashboard-page__table__descr">Need</th>
                    <th>Corporate Sponsor</th>
                    <th>Status</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="startup in startups" :key="startup.key">
                    <td>
                        <div class="dashboard-page__table__title">
                            <div class="data-labels-set data-labels-set--xs">
                                <span class="data-label">
                                    <img :src="getLogo(startup.logo)"/>
                                </span>
                            </div>
                            <h6 class="heading6"><a :href="`/startups/${startup.id}`" target="_blank">{{startup.name}}</a></h6>
                        </div>
                    </td>
                    <td>
                        <h6 class="heading6">
                            <a :href="`/needs/${startup.need_id}`" target="_blank">{{startup.need_name}}</a>
                        </h6>

                        <VClamp autoresize :max-lines="4" class="activity-list__content__text">
                            {{startup.need_description}}

                            <template #after="{ toggle, expanded, clamped }">
                                <a v-if="expanded" class="link-normal" @click="toggle">less</a>
                                <a v-if="clamped" class="link-normal" @click="toggle">more</a>
                            </template>
                        </VClamp>
                    </td>
                    <td>
                        <div class="top-category" :class="`top-category--` + startup.sponsor_category">{{startup.sponsor_label}}</div>
                    </td>
                    <td>
                        <div class="status-plate-wrapper">
                            <span class="status-plate status-plate--strong" :class="statusClasses[startup.status]">{{ statusLabels[startup.status] }}</span>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>

</style>
